import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const LaporanPortfolioBsyaJunior = Loadable(lazy(() => import('./index')));

export const routes: RouteObject[] = [
	{
		path: '/laporan/portfolio-bsya-junior',
		element: <LaporanPortfolioBsyaJunior />,
	},
];
